// extracted by mini-css-extract-plugin
export default {"companyContainer":"ZN-z","companyImage":"_N-z","container":"aO-z","heading":"bO-z","darkText":"cO-z","smallHeading":"dO-z","darkBackground":"eO-z","whiteBackground":"fO-z"};